import { render, staticRenderFns } from "./GlobalSearchField.vue?vue&type=template&id=f2f350b2"
import script from "./GlobalSearchField.vue?vue&type=script&lang=js"
export * from "./GlobalSearchField.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchField.vue?vue&type=style&index=0&id=f2f350b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports